import createAPIAction from 'store/utils/createAPIAction';

const serviceName = 'auth';

export const loginUser = createAPIAction(
  `${serviceName}/LOGIN_USER`,
  (data: { password: string; email: string }) => ({
    endpoint: '/isp-service/login',
    method: 'POST',
    data,
  })
);

/**
 * Exchange an Azure AD access token for app-level JWTs.
 * The Azure token is sent both in the body and as the Authorization header
 * (matching the tools contract with isp-service).
 */
export const exchangeAzureSsoToken = createAPIAction(
  `${serviceName}/AZURE_SSO_EXCHANGE`,
  (azureAccessToken: string) => ({
    endpoint: '/isp-service/azure-sso/exchange',
    method: 'POST',
    data: { azureAccessToken },
    headers: { Authorization: `Bearer ${azureAccessToken}` },
  })
);

/**
 * Fetch the current user's profile, permissions, and groups.
 * Called after a successful token exchange to populate the auth store.
 */
export const getSelf = createAPIAction(`${serviceName}/GET_SELF`, () => ({
  endpoint: '/isp-service/admin/users/self',
}));
